import getSafe from '../../utils/getSafe';
import { getLatLngBoundsFromPins } from '../../utils/map';
import {
  FETCH_HOME_MAP_VIEW_REQUEST,
  FETCH_HOME_MAP_VIEW_SUCCESS,
  FETCH_HOME_MAP_VIEW_FAILURE,
  HOME_TOGGLE_MAP_VIEW,
  SET_HOME_MAP_SELECTED_RESTAURANT_ID,
} from '../../actions/types';

const initialState = {
  cards: [],
  hasError: false,
  isLoading: false,
  isOpen: false,
  latLngBounds: null,
  pins: [],
  selectedRestaurantId: '',
};

const parsePayload = (payload) => {
  const cards = getSafe(() => payload.data.results.layoutGroups[0].data[0].blocks) || [];
  const pins = getSafe(() => payload.data.results.uiMap.pins) || [];
  const selectedRestaurantId = getSafe(() => pins[0].restaurantId) || '';
  const latLngBounds = getLatLngBoundsFromPins(pins);

  return {
    cards,
    latLngBounds,
    pins,
    selectedRestaurantId,
  };
};

const mapReducer = (state = initialState, action = {}) => {
  const { payload, restaurantId, type } = action;

  switch (type) {
    case HOME_TOGGLE_MAP_VIEW:
      return {
        ...state,
        isLoading: true,
        isOpen: !state.isOpen,
      };
    case FETCH_HOME_MAP_VIEW_REQUEST:
      return {
        ...state,
        hasError: false,
      };
    case FETCH_HOME_MAP_VIEW_SUCCESS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        ...parsePayload(payload),
      };
    case FETCH_HOME_MAP_VIEW_FAILURE:
      return {
        ...state,
        cards: [],
        hasError: true,
        isLoading: false,
        pins: [],
        selectedRestaurantId: '',
      };
    case SET_HOME_MAP_SELECTED_RESTAURANT_ID:
      return {
        ...state,
        selectedRestaurantId: restaurantId,
      };
    default:
      return state;
  }
};

export default mapReducer;
